import React, { useEffect, useRef, useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Why from "@/components/Why";
import Gallery from "@/components/Gallery";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Geography from "@/components/Geography";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingDock from "@/components/FloatingDock";
import AuthModal from "@/components/AuthModal";
import LeadPopup from "@/components/LeadPopup";

export default function Landing() {
  const [authOpen, setAuthOpen] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);
  const servicesRef = useRef(null);
  const popupShown = useRef(false);

  // Lead popup auto-trigger after 25s, only once per session
  useEffect(() => {
    if (sessionStorage.getItem("popup_shown") === "1") { popupShown.current = true; return; }
    const id = setTimeout(() => {
      if (!popupShown.current) {
        popupShown.current = true;
        sessionStorage.setItem("popup_shown", "1");
        setLeadOpen(true);
      }
    }, 25000);
    return () => clearTimeout(id);
  }, []);

  return (
    <div className="bg-onyx text-bone overflow-x-hidden">
      <Header onAuth={() => setAuthOpen(true)} onConsult={() => setLeadOpen(true)} />
      <Hero onConsult={() => setLeadOpen(true)} onScrollNext={() => servicesRef.current?.scrollIntoView({ behavior: "smooth" })} />
      <div ref={servicesRef}>
        <Services onConsult={() => setLeadOpen(true)} />
      </div>
      <Why />
      <Gallery />
      <Process />
      <Testimonials />
      <FAQ />
      <Geography />
      <Contact />
      <Footer />
      <FloatingDock />
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
      <LeadPopup open={leadOpen} onClose={() => setLeadOpen(false)} />
    </div>
  );
}
